import script from "./Version.vue?vue&type=script&lang=ts&setup=true"
export * from "./Version.vue?vue&type=script&lang=ts&setup=true"

import "./Version.vue?vue&type=style&index=0&id=331a9fe3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-331a9fe3"]])

export default __exports__